export default class HttpResponse {
  /** @type object */
  data;
  /** @type number */
  statusCode;
  /** @type string */
  statusText;
  /** @type {Object} */
  headers;

  constructor(data, statusCode, statusText, headers) {
    this.data = data;
    this.statusCode = statusCode;
    this.statusText = statusText;
    this.headers = headers;
  }
}
